import { currentProfileState } from 'components/company-profile/state/current-profile';
import { useSnapshot } from 'hooks/use-safe-snapshot';

const useActiveArticle = () => {
    const { activeArticle } = useSnapshot(currentProfileState);

    return {
        activeArticle,
        setActiveArticle: (activeArticle: string | null) => {
            currentProfileState.activeArticle = activeArticle;
        },
    };
};

export { useActiveArticle };
